import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-photographies-edit-mode',
  templateUrl: './photographies-edit-mode.component.html',
  styleUrls: ['./photographies-edit-mode.component.scss'],
})
export class PhotographiesEditModeComponent implements OnChanges {
  @Input() photographies!: Report.Photographs;
  @Input() reportId!: string;

  @Output() photographiesChanged = new EventEmitter<Report.Photographs>();
  @Output() removePhoto = new EventEmitter<number>();

  photographiesForm = new FormGroup({
    titlePhoto1: new FormControl(''),
    titlePhoto2: new FormControl(''),
    titlePhoto3: new FormControl(''),
    titlePhoto4: new FormControl(''),
    titlePhoto5: new FormControl(''),
    titlePhoto6: new FormControl(''),
  });

  photoIndexes = Array.from({ length: 6 }, (_, i) => i);

  currentPhotographies!: Report.Photographs;

  getPhotoByIndex(index: number): string | undefined {
    return this.currentPhotographies?.photographs?.find(
      (p) => p.index === index,
    )?.photo;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photographies']) {
      this.currentPhotographies = structuredClone(
        changes['photographies'].currentValue,
      );
      this.setFormValues();
    }
  }

  onClearPhoto(index: number) {
    this.removePhoto.emit(index);
  }

  onCroppedPhoto(croppedImage: string | undefined, index: number): void {
    if (!this.currentPhotographies) {
      return;
    }

    if (!this.currentPhotographies.photographs) {
      this.currentPhotographies.photographs = [];
    }

    const existingPhoto = this.currentPhotographies.photographs.find(
      (p) => p.index === index,
    );
    if (existingPhoto) {
      existingPhoto.photo = croppedImage;
    } else {
      this.currentPhotographies.photographs.push({
        title: '',
        photo: croppedImage,
        index,
      });
    }
    this.photographiesChanged.emit(this.currentPhotographies);
  }

  titleChanged(event: Event, index: number): void {
    if (!this.currentPhotographies) {
      return;
    }

    if (!this.currentPhotographies.photographs) {
      this.currentPhotographies.photographs = [];
    }

    const existingPhoto = this.currentPhotographies.photographs.find(
      (p) => p.index === index,
    );
    if (existingPhoto) {
      existingPhoto.title = (event.target as HTMLInputElement).value;
    } else {
      this.currentPhotographies.photographs.push({
        title: (event.target as HTMLInputElement).value,
        index,
      });
    }

    this.photographiesChanged.emit(this.currentPhotographies);
  }

  getFormControl(controlName: string): FormControl {
    const control = this.photographiesForm.get(controlName);
    if (!control) {
      throw new Error(`Control with name ${controlName} not found in the form`);
    }
    return control as FormControl;
  }

  private setFormValues(): void {
    if (!this.photographies?.photographs) {
      return;
    }

    const titles = Array.from({ length: 6 }, (_, index) => {
      return (
        this.photographies.photographs.find((p) => p.index === index)?.title ||
        ''
      );
    });

    const controlNames: (keyof typeof this.photographiesForm.controls)[] = [
      'titlePhoto1',
      'titlePhoto2',
      'titlePhoto3',
      'titlePhoto4',
      'titlePhoto5',
      'titlePhoto6',
    ];

    titles.forEach((title, index) => {
      const controlName = controlNames[index];
      this.photographiesForm.controls[controlName].setValue(title);
    });
  }
}
